<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-inspiration">
<h1>The Inspiration</h1>
<p>For this book was a conversation I had with my mother, sitting in the car at a beach, lamenting the difficulty of getting back into the dating scene in Australia. “It shouldn’t be that difficult,” I said. I’m Australian, so culturally no problems, I speak fairly fluent English, and I like to have a chat. But no matter how sociable I was, how much I smiled and how much I opened a conversation, I routinely came up blank. Niente. Not even a coffee invitation. So, either I was a seriously flawed individual, or the men were aspiring nonsensicalities. Now, I am and freely admit that I am a seriously flawed individual – as we all are. But I decided that it was more the second that men in this country were a little warped and a little strange and a little too metro for me.</p>
<p>So, I sat down and started writing a rant, which ended up becoming quite a long rant and gave it to a friend who spent an hour laugh-crying at it.</p>
<p>I thought I’d share it with more people.</p>
<p>So here it is.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?592cdc58